export default __webpack_public_path__ + "static/media/new-graph.4c84a765.png";